import React, { Component } from 'react'
import polyline from '@mapbox/polyline'
import { getMapUrl } from 'common/redux/maps'

export default class GoogleMap extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.bounds && nextProps.bounds !== this.props.bounds) {
      this.getImageUrl(nextProps)
      return false;
    }
    return nextState.mapUrl !== this.state.mapUrl
  }

  componentDidMount() {
    this.getImageUrl(this.props)
  }

  encodeURLPaths(paths) {
    let urlEncodePaths = undefined
    if(window){
      if(Array && Array.isArray(paths)){
        urlEncodePaths = paths.map((path)=>window.encodeURIComponent(path))
      }else{
        urlEncodePaths = window.encodeURIComponent(paths)
      }
    }
    else{urlEncodePaths = paths}
    return urlEncodePaths
  }

  getImageUrl(props) {
    const { bounds, geoJsonData, verifyGeoJsonData, dispatch } = props
    const mapElement = document.getElementsByClassName('google-map')[0]
    const mapDimensions = {
      height: mapElement.clientHeight,
      width: mapElement.clientWidth
    }

    let paths = []
    if (geoJsonData) {
      paths = paths.concat(this.getPathsFromGeoJsonData(geoJsonData, false))
    }

    if (verifyGeoJsonData) {
      paths = paths.concat(this.getPathsFromGeoJsonData(verifyGeoJsonData, true))
    }

    const centerBounds = this.getCenter(bounds)
    const zoom = this.getBoundsZoomLevel(bounds, mapDimensions)
    const urlEncodePaths = this.encodeURLPaths(paths)
    dispatch(getMapUrl(centerBounds.lat, centerBounds.lng, zoom, 1, mapDimensions.width, mapDimensions.height, 'roadmap', urlEncodePaths, 'png', true))
      .then(result => {
        this.setState({mapUrl: result.map_url})
      })
  }

  getPathsFromGeoJsonData(geoJsonData, isVerifyGeoJson) {
    let features = this.convertGeoJsonDataToLineStringFeatures(geoJsonData)

    let paths = []
    const color = isVerifyGeoJson ? '0xff111199' : '0x0054FF99'
    const fillColor = isVerifyGeoJson ? '0xff111128' : '0x0054FF28'
    features.forEach(feature => {
      paths.push(this.convertFeatureToPath(feature, color, fillColor))
    })

    return paths
  }

  convertGeoJsonDataToLineStringFeatures(geoJsonData) {
    let features = []
    if (geoJsonData.type === "MultiPolygon") {
      geoJsonData.coordinates.forEach((feature) => {
        feature.forEach((polygon) => {
          let feature = {
            type: 'LineString',
            coordinates: [],
          }

          polygon.forEach((coord) => {
            feature.coordinates.push(coord)
          })

          features.push(feature)
        })
      })
    }

    if (geoJsonData.type === "Polygon") {
      features.push({
        type: 'LineString',
        coordinates: geoJsonData.coordinates[0]
      })
    }

    return features
  }

  convertFeatureToPath = (feature, color, fillColor) => {
    let path = 'color:' + color + '|weight:2|fillcolor:' + fillColor
    path += '|enc:' + polyline.fromGeoJSON(feature)
    return path
  }

  getCenter = (bounds) => {
    const southwestLat = bounds[0][0]
    const southwestLong = bounds[0][1]
    const northeastLat = bounds[1][0]
    const northeastLong = bounds[1][1]
    return {lat: ((southwestLat+northeastLat)/2), lng: ((southwestLong+northeastLong)/2)}
  }

  getBoundsZoomLevel = (bounds, mapDim) => {
    const WORLD_DIM = { height: 256, width: 256 }
    const ZOOM_MAX = 21

    function latRad(lat) {
        const sin = Math.sin(lat * Math.PI / 180)
        const radX2 = Math.log((1 + sin) / (1 - sin)) / 2
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2
    }

    function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2)
    }

    const ne = bounds[1]
    const sw = bounds[0]

    const latFraction = (latRad(ne[0]) - latRad(sw[0])) / Math.PI

    const lngDiff = ne[1] - sw[1]
    const lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360

    const latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction)
    const lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction)

    return Math.min(latZoom, lngZoom, ZOOM_MAX)
}

  render() {
    const { mapUrl } = this.state

    return (
      <div ref={(mapDiv) => {this.mapDiv = mapDiv}} className='google-map'>
        <img src={mapUrl}/>
      </div>
    )
  }
}
